module.exports = __webpack_public_path__ + "assets/media/lunch.dd17d640.mp3";